import { createClient } from "@supabase/supabase-js";
import { isNativeShell } from "./native/nativeShell";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined;

if (!supabaseUrl || !supabasePublishableKey) {
  throw new Error(
    "Missing Supabase environment variables. Set VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY."
  );
}

export const supabase = createClient(supabaseUrl, supabasePublishableKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // The native shell needs PKCE so the sign-in callback carries ?code= instead of a hash fragment.
    flowType: isNativeShell() ? "pkce" : "implicit",
    debug: false,
  },
});
